import { render, staticRenderFns } from "./avalonMenuFontsLibrary.vue?vue&type=template&id=770a948c&scoped=true&"
import script from "./avalonMenuFontsLibrary.vue?vue&type=script&lang=js&"
export * from "./avalonMenuFontsLibrary.vue?vue&type=script&lang=js&"
import style0 from "./avalonMenuFontsLibrary.vue?vue&type=style&index=0&id=770a948c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770a948c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VProgressLinear,VSheet})
